import BackTop from './back-top';

export default BackTop;
export type * from './types';
